export default __webpack_public_path__ + "static/media/1.4fb2a2f9.png";